import { h } from "@stencil/core";

interface WrapperProps {
    linkWrapper?: boolean;
}

export const Wrapper = (props: WrapperProps, children) => {
    if (props.linkWrapper) {
        return <ux-iws-link-wrapper>{children}</ux-iws-link-wrapper>;
    }
    return children;
};
